module.exports = __webpack_public_path__ + "static/media/tipologia5.831ec44c.png";